export default "__VITE_ASSET__CKcQqpYo__"